module.exports = __webpack_public_path__ + "img/PR1.0f3ac560.png";